import { GridColumns, GridRenderCellParams } from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React from 'react';
import { GeneralHelper } from './GeneralHelper';
import PublishIcon from '@mui/icons-material/Publish';
import ErrorIcon from '@mui/icons-material/Error';
import BugReportIcon from '@mui/icons-material/BugReport';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import RemoveIcon from '@mui/icons-material/Remove';
import { ThemeProvider, Tooltip } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { PaymentsEftRecordStatus, PaymentsEftRecordType } from '../models/DeprecatedEnums';



export class EftStatementHelper {
  public static getMemberLinkColumns(linkSelectedMember: (member: any) => void): GridColumns {
    const handleSelectedMember = (member: any) => {
      console.log('link button clicked');
      linkSelectedMember(member);
    };
    return [
      {
        field: '',
        headerName: '',
        width: 100,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <div>
              <Button variant="outlined" onClick={event => handleSelectedMember(params.row)}>
                Link
              </Button>
            </div>
          );
        }
      },
      {
        field: 'id',
        headerName: 'Id',
        width: 60,
        editable: false
      },
      {
        field: 'firstName',
        headerName: 'First Name',
        width: 150,
        editable: false
      },
      {
        field: 'lastName',
        headerName: 'Last Name',
        width: 170,
        editable: false
      },
      {
        field: 'emailAddress',
        headerName: 'Email Address',
        width: 300,
        editable: false
      },
      {
        field: 'country',
        headerName: 'Country',
        width: 80,
        editable: false
      },
      {
        field: 'dob',
        headerName: 'Date of Birth',
        width: 130,
        editable: false,
        renderCell: (params: GridRenderCellParams) => {
          if (params.value) {
            return <span>{GeneralHelper.formatDate(params.value)}</span>;
          }
          return <span />;
        }
      },
      {
        field: 'city',
        headerName: 'City',
        width: 100,
        editable: false
      },
      {
        field: 'address',
        headerName: 'Address',
        width: 150,
        editable: false
      }
    ];
  }

  public static getEftStatementColumns(
    handleClick: (event: React.MouseEvent<HTMLElement>) => void,
    setSelectedRecord: (record: any) => void,
    handleStatusClick: (record: any) => void,
    handleTypeClick: (record: any) => void,
    handleReferenceClick: (reference: string) => void
  ): GridColumns {
    const robot_font = "'Roboto Mono', monospace";
    const robot_theme = createTheme({
      typography: {
        fontFamily: robot_font
      }
    });

    const handleRecordAction = (event: React.MouseEvent<HTMLElement>, record: any) => {
      handleClick(event);
      setSelectedRecord(record);
    };

    const statusClick = (record: any) => {
      handleStatusClick(record);
    };

    return [
      {
        field: '',
        headerName: 'Actions',
        width: 80,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <div>
              <IconButton aria-label="delete" onClick={event => handleRecordAction(event, params.row)}>
                <MoreVertIcon />
              </IconButton>
            </div>
          );
        }
      },
      {
        field: 'status',
        headerName: 'Status',
        width: 205,
        editable: false,
        renderCell: (params: GridRenderCellParams) => {
          switch (params.value) {
            case 'PROCESSED':
              return (
                <Button
                  fullWidth={true}
                  variant="outlined"
                  color="primary"
                  disabled={
                    !(
                      params.row !== null &&
                      (params.row.status === PaymentsEftRecordStatus.PENDING || params.row.status === PaymentsEftRecordStatus.IGNORE)
                    )
                  }
                  onClick={event => statusClick(params.row)}
                >
                  {params.value}
                </Button>
              );
            case 'DUPLICATE':
              return (
                <Button
                  fullWidth={true}
                  variant="outlined"
                  color="error"
                  disabled={
                    !(
                      params.row !== null &&
                      (params.row.status === PaymentsEftRecordStatus.PENDING ||
                        params.row.status === PaymentsEftRecordStatus.IGNORE ||
                        params.row.status === PaymentsEftRecordStatus.DUPLICATE)
                    )
                  }
                  onClick={event => statusClick(params.row)}
                >
                  <BugReportIcon />
                  {params.value}
                </Button>
              );
            case 'IGNORE':
              return (
                <Button
                  fullWidth={true}
                  variant="outlined"
                  color="warning"
                  disabled={
                    !(
                      params.row !== null &&
                      (params.row.status === PaymentsEftRecordStatus.PENDING || params.row.status === PaymentsEftRecordStatus.IGNORE)
                    )
                  }
                  onClick={event => statusClick(params.row)}
                >
                  <VisibilityOffIcon />
                  {params.value}
                </Button>
              );
            case 'IGNORE_PROCESSED':
              return (
                <Button
                  fullWidth={true}
                  variant="outlined"
                  color="inherit"
                  disabled={
                    !(
                      params.row !== null &&
                      (params.row.status === PaymentsEftRecordStatus.PENDING || params.row.status === PaymentsEftRecordStatus.IGNORE)
                    )
                  }
                  onClick={event => statusClick(params.row)}
                >
                  {params.value}
                </Button>
              );
            case 'ERROR':
              return (
                <Button fullWidth={true} variant="outlined" color="error" onClick={event => statusClick(params.row)}>
                  <ErrorIcon />
                  {params.value}
                </Button>
              );
            default:
              return (
                <Button
                  fullWidth={true}
                  variant="outlined"
                  color="success"
                  disabled={
                    !(
                      params.row !== null &&
                      (params.row.status === PaymentsEftRecordStatus.PENDING || params.row.status === PaymentsEftRecordStatus.IGNORE)
                    )
                  }
                  onClick={event => statusClick(params.row)}
                >
                  <PublishIcon />
                  {params.value}
                </Button>
              );
          }
        }
      },

      { field: 'id', headerName: 'ID', width: 50 },
      {
        field: 'transactionDate',
        headerName: 'Date',
        type: 'text',
        width: 100,
        renderCell: (params: GridRenderCellParams) => {
          return <span>{GeneralHelper.formatDate(params.value, false, 'DD/MM/YYYY')}</span>;
        }
      },
      {
        field: 'amount',
        headerName: 'Amount',
        width: 130,
        editable: false,
        align: 'right',
        renderCell: (params: GridRenderCellParams) => {
          return <span>{GeneralHelper.formatCurrency(params.value)}</span>;
        }
      },
      {
        field: 'originalDescription2',
        headerName: 'Description #2',
        width: 300,
        editable: false
      },
      {
        field: 'referenceUsed',
        headerName: 'Proxima Ref#',
        width: 150,
        editable: false,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <ThemeProvider theme={robot_theme}>
              <Button fullWidth={true} onClick={event => handleReferenceClick(params.value)}>
                {params.value}
              </Button>
            </ThemeProvider>
          );
        }
      },
      {
        field: 'recordType',
        headerName: 'Type',
        width: 150,
        editable: false,
        renderCell: (params: GridRenderCellParams) => {
          switch (params.value) {
            case 'EFT':
              return (
                <Button
                  fullWidth={true}
                  variant="outlined"
                  color="primary"
                  disabled={
                    !(
                      params.row !== null &&
                      (params.row.status === PaymentsEftRecordStatus.PENDING || params.row.status === PaymentsEftRecordStatus.IGNORE)
                    )
                  }
                  onClick={event => handleTypeClick(params.row)}
                >
                  {params.value}
                </Button>
              );
            case 'SWIFT':
              return (
                <Button
                  fullWidth={true}
                  variant="outlined"
                  color="secondary"
                  disabled={
                    !(
                      params.row !== null &&
                      (params.row.status === PaymentsEftRecordStatus.PENDING || params.row.status === PaymentsEftRecordStatus.IGNORE)
                    )
                  }
                  onClick={event => handleTypeClick(params.row)}
                >
                  {params.value}
                </Button>
              );
            case 'CASH':
              return (
                <Button
                  fullWidth={true}
                  variant="outlined"
                  color="success"
                  disabled={
                    !(
                      params.row !== null &&
                      (params.row.status === PaymentsEftRecordStatus.PENDING || params.row.status === PaymentsEftRecordStatus.IGNORE)
                    )
                  }
                  onClick={event => handleTypeClick(params.row)}
                >
                  {params.value}
                </Button>
              );
            case 'FEE':
              return (
                <Button
                  fullWidth={true}
                  variant="outlined"
                  color="error"
                  disabled={
                    !(
                      params.row !== null &&
                      (params.row.status === PaymentsEftRecordStatus.PENDING || params.row.status === PaymentsEftRecordStatus.IGNORE)
                    )
                  }
                  onClick={event => handleTypeClick(params.row)}
                >
                  {params.value}
                </Button>
              );
            default:
              return (
                <Button
                  fullWidth={true}
                  variant="outlined"
                  color="inherit"
                  disabled={
                    !(
                      params.row !== null &&
                      (params.row.status === PaymentsEftRecordStatus.PENDING || params.row.status === PaymentsEftRecordStatus.IGNORE)
                    )
                  }
                  onClick={event => handleTypeClick(params.row)}
                >
                  {params.value}
                </Button>
              );
          }
        }
      },
      {
        field: 'popReceived',
        headerName: 'POP',
        description: 'Proof of payment received',
        width: 70,
        editable: false,
        renderCell: (params: GridRenderCellParams) => {
          if (params.value === true || params.value === 'true') {
            return <FactCheckIcon color={'success'} />;
          } else {
            if (
              params.row.recordType === PaymentsEftRecordType.EFT ||
              params.row.recordType === PaymentsEftRecordType.SWIFT ||
              params.row.recordType === PaymentsEftRecordType.CASH
            ) {
              if (!params.row.referenceUsed || params.row.referenceUsed === '') {
                if (params.row.status === PaymentsEftRecordStatus.IGNORE) {
                  return <RemoveIcon />;
                } else {
                  return (
                    <Tooltip title="Proof of Payment required.">
                      <AnnouncementIcon color={'warning'} />
                    </Tooltip>
                  );
                }
              }
            }
          }
          return <RemoveIcon />;
        }
      },
      {
        field: 'memberId',
        headerName: 'Member',
        description: 'Linked Member Details',
        width: 350,
        editable: false,
        renderCell: (params: GridRenderCellParams) => {
          if (params.value !== null) {
            if (
              params.row.recordType === PaymentsEftRecordType.EFT ||
              params.row.recordType === PaymentsEftRecordType.SWIFT ||
              params.row.recordType === PaymentsEftRecordType.CASH
            ) {
              return (
                <span>
                  {params.row.memberName} [{params.row.memberEmail}]
                </span>
              );
            }
          }
          return <span />;
        }
      }
    ];
  }
}
